import { Component, OnInit } from '@angular/core';
import { BaseModal } from 'shared/abstract/base-modal';

@Component({
    selector: 'app-table-widget-delete-row-modal',
    templateUrl: './table-widget-delete-row-modal.component.html',
    styleUrls: ['../../../../../shared/components/modal/modal.component.scss', './table-widget-delete-row-modal.component.scss'],
    standalone: false,
})
export class TableWidgetDeleteRowModalComponent extends BaseModal implements OnInit {
    public data!: {
        columns: any[];
        deletedEntityValue: string;
        deletedEntityType: string;
        isWithCompanyConfirmation: boolean;
        confirmationInputPlaceholder: string;
        type: 'top' | 'side' | 'center';
        shouldNotTranslatePlaceholder: boolean;
    };

    public displayDeleteAndApplyRoomAmenitiesSetButton: boolean = false;

    public confirmationInput: string = '';

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.data.columns = this.data.columns.filter((column) => Object.keys(this.data.deletedEntityValue).includes(column.dataKey));
        this.displayDeleteAndApplyRoomAmenitiesSetButton =
            this.data.deletedEntityType === 'listing.roomType.roomAmenitiesSets.roomAmenitiesSets.label';
    }

    public close(result: any): void {
        this.closeModalInstance(result);
    }

    public confirmationInputOnKeyUp($event: any) {
        this.confirmationInput = $event?.target.value;
    }
}
